import React from 'react';
import PropTypes from 'prop-types';
import Select from 'shared/inputs/Select';
import Icon from 'shared/icons/IconComponent';
import RequiredMark from 'shared/inputs/RequiredMark';
import get from 'lodash/get';

/**
 * @deprecated Use Telerik or shared components instead.
 */
const FormikSelect = ({
  label,
  options,
  filterDeleted, // the options must be mapped out with a deleted prop for this to work
  onChange,
  onBlur,
  value,
  wrapperClass,
  touched,
  errors,
  menuPlacement,
  quickAddClick,
  quickAddIcon,
  forceQuickAddEnabled,
  quickAddTitle,
  formatOptionLabel = null,
  labelStyle = {},
  touchedNested = false,
  ...selectProps
}) => {
  const hasError = get(errors, selectProps.name) && (touchedNested || get(touched, selectProps.name));

  if (typeof value !== 'object' && Array.isArray(options)) {
    const option = options.filter((x) => x.value === value);
    if (option.length) {
      value = option[0];
    }
  }

  const select = (
    <Select
      id={selectProps.name}
      className={`select ${hasError ? 'error' : ''}`}
      value={value}
      onChange={(selectedOption) => onChange(selectedOption)}
      options={filterDeleted ? options?.filter((x) => !x.deleted) : options}
      isDisabled={selectProps.disabled}
      menuPlacement={menuPlacement}
      formatOptionLabel={formatOptionLabel}
      {...(onBlur && { onBlur: () => onBlur(selectProps.name) })}
      {...selectProps}
    />
  );

  return (
    <div className={`formik-wrapper ${wrapperClass || ''}`}>
      <label style={labelStyle} htmlFor={selectProps.name}>
        {label}
        {selectProps.required ? <RequiredMark /> : null}
      </label>
      {quickAddClick ? (
        <div className='input-items-container'>
          {select}
          <button
            className='button secondary text-align--center margin--off'
            disabled={selectProps.disabled && !forceQuickAddEnabled}
            onClick={quickAddClick}
            type='button'
            title={quickAddTitle || ''}
          >
            <Icon icon={quickAddIcon || 'plus-circle'} position='none' className='icon--adjust-top font-size--large' />
          </button>
        </div>
      ) : (
        select
      )}
      {hasError && <div className='feedback'>{get(errors, selectProps.name)}</div>}
    </div>
  );
};

FormikSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
    ),
  ]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ).isRequired,
  touched: PropTypes.object,
  errors: PropTypes.object,
  selectProps: PropTypes.object,
  wrapperClass: PropTypes.string,
};

export default FormikSelect;
